<template>
  <div class="child-wrapper">
    <BalletAndDance v-if="catId=='ballet-dance'"></BalletAndDance>
    <ChildrenFamily v-if="catId=='children-family'"></ChildrenFamily>
    <ClassicalMusic v-if="catId=='classical-music'"></ClassicalMusic>
    <FestivalsMultiCategory v-if="catId=='festivals-multi-category'"></FestivalsMultiCategory>
    <FestivalsSingleCategory v-if="catId=='festivals-single-category'"></FestivalsSingleCategory>
    <MusicalTheatre v-if="catId=='musical-theatre'"></MusicalTheatre>
    <ContemporaryMusic v-if="catId=='contemporary-music'"></ContemporaryMusic>
    <Opera v-if="catId=='opera'"></Opera>
    <SpecialEvents v-if="catId=='special-events'"></SpecialEvents>
    <Theatre v-if="catId=='theatre'"></Theatre>
    <CircusPhysicalTheatre v-if="catId=='circus-physical-theatre'"></CircusPhysicalTheatre>
    <Comedy v-if="catId=='comedy'"></Comedy>
  </div>
</template>

<script>
import BalletAndDance from './2019/BalletAndDance'
import ChildrenFamily from './2019/ChildrenFamily'
import ClassicalMusic from './2019/ClassicalMusic'
import FestivalsMultiCategory from './2019/FestivalsMultiCategory'
import FestivalsSingleCategory from './2019/FestivalsSingleCategory'
import MusicalTheatre from './2019/MusicalTheatre'
import ContemporaryMusic from './2019/ContemporaryMusic'
import Opera from './2019/Opera'
import SpecialEvents from './2019/SpecialEvents'
import Theatre from './2019/Theatre'
import CircusPhysicalTheatre from './2019/CircusPhysicalTheatre'
import Comedy from './2019/Comedy'

export default {
  components: {
    BalletAndDance,
    ChildrenFamily,
    ClassicalMusic,
    FestivalsMultiCategory,
    FestivalsSingleCategory,
    MusicalTheatre,
    ContemporaryMusic,
    Opera,
    SpecialEvents,
    Theatre,
    CircusPhysicalTheatre,
    Comedy
  },
  data () {
    return {
    }
  },
  props: ['catId'],
  mounted () {
  },
  methods: {
  }
}
</script>
